import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { CalculatedVariable } from 'src/app/models/calculated-variable';

export const getCalculatedVariablesForStudy = createAction(
  '[CalculatedVariable] Get Calculated Variables For Study',
  props<{ studyId: number }>()
);

export const getCalculatedVariablesForStudySuccess = createAction(
  '[CalculatedVariable] Get Calculated Variables For Study Success',
  props<{ calculatedVariablesForStudy: CalculatedVariable[] }>()
);

export const getCalculatedVariablesForStudyError = createAction(
  '[CalculatedVariable] Get Calculated Variables For Study Error',
  props<{ err: HttpErrorResponse }>()
);

export const createCalculatedVariable = createAction(
  '[CalculatedVariable] Create Calculated Variable',
  props<{ calculatedVariable: CalculatedVariable }>()
);

export const createCalculatedVariableSuccess = createAction(
  '[CalculatedVariable] Create Calculated Variable Success',
  props<{ createdCalculatedVariable: CalculatedVariable }>()
);

export const createCalculatedVariableError = createAction(
  '[CalculatedVariable] Create Calculated Variable Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateCalculatedVariable = createAction(
  '[CalculatedVariable] Update Calculated Variable',
  props<{ calculatedVariable: CalculatedVariable }>()
);

export const updateCalculatedVariableSuccess = createAction(
  '[CalculatedVariable] Update Calculated Variable Success',
  props<{ updatedCalculatedVariable: CalculatedVariable }>()
);

export const updateCalculatedVariableError = createAction(
  '[CalculatedVariable] Update Calculated Variable Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteCalculatedVariable = createAction(
  '[CalculatedVariable] Delete Calculated Variable',
  props<{ calculatedVariable: CalculatedVariable }>()
);

export const deleteCalculatedVariableSuccess = createAction(
  '[CalculatedVariable] Delete Calculated Variable Success',
  props<{ deletedCalculatedVariable: CalculatedVariable }>()
);

export const deleteCalculatedVariableError = createAction(
  '[CalculatedVariable] Delete Calculated Variable Error',
  props<{ err: HttpErrorResponse }>()
);

export const getCalculatedVariablesForModule = createAction(
  '[CalculatedVariable] Get Calculated Variables For Module',
  props<{ studyId: number; moduleId: number }>()
);

export const getCalculatedVariablesForModuleSuccess = createAction(
  '[CalculatedVariable] Get Calculated Variables For Module Success',
  props<{ calculatedVariablesForModule: CalculatedVariable[] }>()
);

export const getCalculatedVariablesForModuleError = createAction(
  '[CalculatedVariable] Get Calculated Variables For Module Error',
  props<{ err: HttpErrorResponse }>()
);
